module.exports = __webpack_public_path__ + "static/media/workingmemory-words-10.ff0209ee.mp3";